import dayjs from 'dayjs'

export interface CommonUtilInterface {
  getGUID: (push?: boolean) => string
  setCookie: (cName: string, cValue: string, time?: number) => void
  getCookie: (cName: string) => string
  deleteCookie: (cName: string) => void
}

const CommonUtils: CommonUtilInterface = {
  getGUID (push) {
    const guidFunc = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    if (push) {
      return `${guidFunc()}${guidFunc()}${guidFunc()}${guidFunc()}`
    } else {
      return `${guidFunc()}${guidFunc()}-${guidFunc()}-${guidFunc()}-${guidFunc()}-${guidFunc()}${guidFunc()}${guidFunc()}`
    }
  },
  setCookie: function (cName: string, cValue: string, time?: number): void {
    const timeout = dayjs(Date.now())
      .add(time ?? 1, 'hour')
      .toString()
    // console.log("setcookie timeout ", timeout)
    document.cookie = `${cName}=${cValue};expires=${timeout};"`
  },
  getCookie: function (cName: string): string {
    cName += '='
    const cookieData = document.cookie
    let start = cookieData.indexOf(cName)
    let cValue = ''
    if (start !== -1) {
      start += cName.length
      let end = cookieData.indexOf(';', start)
      if (end === -1) end = cookieData.length
      cValue = cookieData.substring(start, end)
    }
    return unescape(cValue)
  },
  deleteCookie: function (cName: string): void {
    // console.log("delete cookie")
    document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  }
}

export default CommonUtils
